import type {TypeformTakeQuizTriggerStruct} from '@cohort/shared/apps/typeform/triggers/takeQuiz';
import type {TriggerIntegrationUsageComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import TypeformWidget from '@cohort/wallet/apps/typeform/triggerIntegrations/TypeformWidget';

const TypeformTakeQuizUsageComponent: React.FC<
  TriggerIntegrationUsageComponentProps<TypeformTakeQuizTriggerStruct>
> = ({onTriggerIntegrationUsageSuccess, config}) => (
  <TypeformWidget formId={config.formId} onSubmit={onTriggerIntegrationUsageSuccess} />
);

export default TypeformTakeQuizUsageComponent;
